<template>
  <div>

    <List
      v-bind:headers="headers"
      v-bind:formview="formview"
      v-bind:table="table"

      v-bind:addbutton="false"
      v-bind:default_limit="'500'"
      v-bind:default_sort="'pickup_timestamp'"
      v-bind:default_sort_typ="'DESC'"
      v-bind:filter_clearing="true"
      v-bind:extension="getExtension()"
      v-bind:export_csv="true"
      ref="listComponent"
      @filterChange="onFilterChange"
    ></List>
  </div>
</template>

<script>
import List from '@/components/ListDefault'

export default {
  name: "ListClearing",
  
  components: {
    List,
  },
  
  created() {
    // Check if there is a saved search term in localStorage

    const savedSearch = localStorage.getItem(this.getStorageKey());
    if (savedSearch && savedSearch.trim() !== '') {
      this.$nextTick(() => {
        if (this.$refs.listComponent) {
          this.$refs.listComponent.search = savedSearch;
        }
      });
    }
    
    // Check if there is a saved group type in localStorage
    const savedGroupType = localStorage.getItem(this.getGroupTypeStorageKey());
    if (savedGroupType) {
      this.$nextTick(() => {
        if (this.$refs.listComponent) {
          try {
            this.$refs.listComponent.selected_group_type = JSON.parse(savedGroupType);
          } catch (e) {
            console.error('Error parsing saved group type:', e);
          }
        }
      });
    }
  },
  
  data () {
    return { 

      formview: 'FormClearing',
      table: 'task',
      filter:{
        selector: 'prio',
        value: '99',
      },
      showOnlyNotInvoiced: false
    }
  },
  
  methods: {
    getStorageKey() {
      return `searchValue_${this.$route.path}`;
    },
    
    getGroupTypeStorageKey() {
      return `selectedGroupType_${this.$route.path}`;
    },
    getExtension() {

      let baseExtension = '(pickup_date IS NOT NULL AND pickup_date<>\'\')';  
      if (this.showOnlyNotInvoiced) {
        return baseExtension + ' AND (invoice IS NULL OR invoice=\'\')';
      }
      
      return baseExtension;
    },
    
    onFilterChange(filterData) {
      console.log("--change filter---:", filterData);
      this.showOnlyNotInvoiced = filterData.showNotCleared;
      if (this.$refs.listComponent && filterData.customerSearch) {
        this.$refs.listComponent.search = filterData.customerSearch;
      }
    }
  },
  
  computed: {
    headers () {
      return [
        { text: 'Tour', value: 'tour_id' },
        { text: 'Nr.', value: 'id' },
        { text: 'Abholdatum', value: 'pickup_timestamp' },
        { text: 'Auftragsnummer', value: 'document_no' },
        { text: 'Kundengruppe', value: 'group_main_text' },
        { text: 'Untergruppe', value: 'group_type_text' },
        { text: 'Kunde', align: 'start', sortable: true, value: 'company' },
        { text: 'Anzahl', value: 'pickup_qty' },
        { text: 'Artikel', value: 'article_name' },
        { text: 'Gesamtbetrag', value: 'price_total' },
        { text: 'Restreifen', value: 'rest' },
        { text: 'Rechnung', value: 'invoice' },
        { text: '', value: 'edit' },
      ]
    },
  },



}
</script>

<style scoped>

</style>
